var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 80,
    viewBox: "0 0 80 80",
    width: 80,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#989898"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m25.9375 70c-3.2751 0-5.9375-3.1167-5.9375-6.9444v-46.1112c0-3.8305 2.6624-6.9444 5.9375-6.9444h26.125c3.2728 0 5.9375 3.1139 5.9375 6.9444v46.1112c0 3.8277-2.6647 6.9444-5.9375 6.9444zm-3.5625-6.9444c0 2.2972 1.5984 4.1666 3.5625 4.1666h26.125c1.9641 0 3.5625-1.8694 3.5625-4.1666v-4.1667h-33.25zm33.25-6.9445v-39.1667c0-2.2972-1.5984-4.1666-3.5625-4.1666h-26.125c-1.9641 0-3.5625 1.8694-3.5625 4.1666v39.1667z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33.0625 18.3333c-.6555 0-1.1875-.6222-1.1875-1.3889 0-.7666.532-1.3888 1.1875-1.3888h11.875c.6555 0 1.1875.6222 1.1875 1.3888 0 .7667-.532 1.3889-1.1875 1.3889z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39 64.4444c.9838 0 1.7813-.9327 1.7813-2.0833s-.7975-2.0833-1.7813-2.0833-1.7813.9327-1.7813 2.0833.7975 2.0833 1.7813 2.0833z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPhone);
export default __webpack_public_path__ + "static/media/ico_phone.1d42a3464ef81583a7e84d269291dd4b.svg";
export { ForwardRef as ReactComponent };